import React from 'react';
import { cn } from '../../lib/utils';

/** A decorative Lucide icon; accessible names belong to its surrounding control. */
export function IconBadge({ icon: Icon, tone = 'primary', size = 'md', className, iconClassName }) {
  if (!Icon) return null;
  return <span data-slot="icon-badge" data-tone={tone} data-size={size}
    className={cn('office-icon-badge', className)} aria-hidden="true">
    <Icon className={iconClassName} size={size === 'sm' ? 16 : 18} strokeWidth={1.75} />
  </span>;
}
